<template>
  <Modal ref="modal" title="Editar auto escola" data-testid="edit-cfc-modal">
    <form @submit.prevent="handleSubmit" class="modal-form" data-testid="edit-cfc-form">
      <div class="inputs">
        <div class="inputs-row" data-testid="row-search">
          <Input mask="##.###.###/####-##" legend="CNPJ" placeholder="00.000.000/0000-00" :modelValue="cnpj"
            @update:modelValue="$event => cnpj = $event" class="input-full input-cnpj"
            data-testid="input-cnpj" />

          <Input legend="Auto escola" placeholder="Preencha o CNPJ para buscar a auto escola" :modelValue="autoescola"
            readonly class="input-full" data-testid="input-nome-autoescola" />

          <Button type="button" text="Pesquisar" color="primary" :fill="false" :disabled="loading"
            @handle:click="getGetranCfc" data-testid="button-pesquisar-cfc">
            <Magnify :size="18" />
          </Button>
        </div>

        <div class="divider">
          <span>Informações gerais</span>
        </div>

        <div class="inputs-row" data-testid="row-informacoes-gerais-1">
          <Input legend="Razão social" :modelValue="razaoSocial" readonly class="input-full"
            data-testid="input-razao-social" />

          <Input legend="Endereço" :modelValue="endereco" readonly class="input-full"
            data-testid="input-endereco" />

          <Input legend="Número" :modelValue="numero" class="input-full input-numero"
            data-testid="input-numero" />
        </div>

        <div class="inputs-row" data-testid="row-contatos">
          <Input type="email" legend="Email" :modelValue="email" class="input-full"
            data-testid="input-email" />

          <Input :mask="['(##) ####-####', '(##) #####-####']" legend="Telefone" :modelValue="fone"
            class="input-full input-telefone" data-testid="input-telefone" />
        </div>

        <div class="divider">
          <span>Coordenadas principais</span>
        </div>

        <div class="inputs-row" data-testid="row-coordenadas-principais">
          <Input legend="Latitude" :modelValue="lat" readonly class="input-full"
            data-testid="input-lat" />

          <Input legend="Longitude" :modelValue="lon" readonly class="input-full"
            data-testid="input-lon" />
        </div>

        <div class="divider">
          <span>Coordenadas categoria A</span>
        </div>

        <div class="inputs-row" data-testid="row-coordenadas-categoria-a">
          <Input legend="Latitude" :modelValue="lat_categoria_a" readonly class="input-full"
            data-testid="input-lat-categoria-a" />

          <Input legend="Longitude" :modelValue="lng_categoria_a" readonly class="input-full"
            data-testid="input-lon-categoria-a" />
        </div>
      </div>

      <div class="buttons" data-testid="edit-cfc-actions">
        <Button type="submit" text="Atualizar" color="primary" :disabled="loading" data-testid="button-atualizar-cfc">
          <Autorenew :size="18" />
        </Button>
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Input from 'core/Input'
import Button from 'core/Button'
import Magnify from 'icons/Magnify'
import Autorenew from 'icons/Autorenew'
import utils from '../../services/utils'

export default {
  name: 'EditCFCModal',
  components: {
    Modal,
    Input,
    Button,

    Magnify,
    Autorenew,
  },
  data() {
    return {
      cfc: null,
      cnpj: '',
      autoescola: '',
      razaoSocial: '',
      endereco: '',
      numero: '',
      email: '',
      fone: '',
      lat: '',
      lon: '',
      lat_categoria_a: '',
      lng_categoria_a: '',
      loading: false,
    }
  },
  methods: {
    open(cfc) {
      this.cfc = cfc

      this.cnpj = cfc.cnpj
      this.autoescola = cfc.nome_fantasia
      this.razaoSocial = cfc.razao_social
      this.endereco = cfc.endereco
      this.numero = cfc.numero
      this.email = cfc.email
      this.fone = cfc.telefone
      this.lat = cfc.lat
      this.lon = cfc.lon
      this.lat_categoria_a = cfc.lat_categoria_a
      this.lng_categoria_a = cfc.lng_categoria_a

      this.$refs.modal.open()
    },
    async getGetranCfc() {
      this.loading = true

      const cnpj = this.cnpj.replace(/[^\d]+/g, '')

      this.$http.get(`${process.env.VUE_APP_URL_API.replace('/v1', '')}/autoescolas/${cnpj}`)
        .then(res => {
          const dados = res.body.dados[0]

          this.razaoSocial = dados.razaoSocial
          this.endereco = `${dados.logradouro}, ${dados.bairro}, ${dados.cidade}`
          this.numero = dados.numero
          this.email = dados.email
          this.fone = `859${dados.telefone1}`
          this.lat = dados.lat
          this.lon = dados.lon
          this.lat_categoria_a = dados.latCatA
          this.lng_categoria_a = dados.lonCatA
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-info',
            position: 'top-right',
            duration: 3000,
            fullWidth: false
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleSubmit() {
      this.loading = true

      const data = {
        cnpj: utils.formatarCNPJ(this.cnpj),
        razao_social: this.razaoSocial,
        endereco: this.endereco,
        numero: this.numero,
        email: this.email,
        fone: this.fone,
        lat: this.lat,
        lon: this.lon,
        lat_categoria_a: this.lat_categoria_a,
        lng_categoria_a: this.lng_categoria_a,
      }

      await this.$http.put(`${process.env.VUE_APP_URL_API_V2}/autoescola/atualizar/${this.cfc.id_cfc}`, data)
        .then(res => {
          this.$toasted.show(res.body.mensagem, {
            icon: 'fa-check',
            position: 'top-right',
            duration: 3000,
            fullWidth: false
          })

          this.$refs.modal.close()

          this.$emit('cfcUpdated')
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-info',
            position: 'top-right',
            duration: 3000,
            fullWidth: false
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>

<style scoped lang="scss">
.modal-form {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .inputs {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .inputs-row {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      gap: 1.5rem;

      .input-full {
        flex: 1;
      }
    }
  }

  .divider {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    &::before,
    &::after {
      content: '';
      flex: 1 1 0;
      height: 1px;
      background-color: #e5e7eb;
    }

    span {
      white-space: nowrap;
      color: #6b7280;
      font-weight: 600;
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
  }

  .buttons {
    align-self: flex-end;

    display: flex;
    gap: 0.5rem;
  }
}

@media (max-width: 600px) {
  ::v-deep(.core-modal-dialog) {
    margin: 1rem auto;
  }

  ::v-deep(.core-modal-content) {
    width: calc(100% - 2rem);
    padding: 1rem;
    max-width: none;
  }
}

@media (min-width: 601px) and (max-width: 1280px) {
  ::v-deep(.core-modal-content) {
    width: 42rem;
  }

  .input-telefone {
    max-width: 10rem;
  }

  .input-cnpj {
    max-width: 12rem;
  }

  .input-numero {
    max-width: 7rem;
  }
}

@media (min-width: 1281px) {
  ::v-deep(.core-modal-content) {
    width: 60rem;
  }

  .input-telefone {
    max-width: 10rem;
  }

  .input-cnpj {
    max-width: 12rem;
  }

  .input-numero {
    max-width: 7rem;
  }
}
</style>